import { isRouteErrorResponse, useRouteError, useNavigate } from "react-router-dom";
import { VStack, Heading, Text, Button, Box, Center } from "@chakra-ui/react";
import { usePostHog } from "@posthog/react";
import { useEffect } from "react";
import { MdErrorOutline, MdRefresh, MdHome } from "react-icons/md";
import { route } from './paths';

export function GlobalRouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  const posthog = usePostHog();

  useEffect(() => {
    if (!isRouteErrorResponse(error)) {
      posthog.captureException(error);
    }
  }, [error, posthog]);

  let title = "Oops! Something went wrong.";
  let description = "We're sorry, but an unexpected error occurred. Our team has been notified.";
  
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Page Not Found";
      description = "The page you are looking for doesn't exist or has been moved.";
    } else if (error.status === 401) {
      title = "Unauthorized";
      description = "You don't have permission to access this page. Please log in again.";
    } else if (error.status === 503) {
      title = "Service Unavailable";
      description = "Looks like our API is down. Please try again later.";
    } else {
      title = `${error.status} Error`;
      description = error.data?.message || error.statusText;
    }
  }

  return (
    <Box minH="100dvh" w="full" bg="bg.canvas" display="flex" alignItems="center" justifyContent="center" p={4}>
      <VStack gap={6} maxW="md" w="full" bg="bg.panel" p={8} borderRadius="lg" boxShadow="md" textAlign="center">
        <Center w={20} h={20} borderRadius="full" bg="red.subtle" color="red.fg">
          <MdErrorOutline size={40} />
        </Center>
        
        <VStack gap={2}>
          <Heading size="xl" color="fg">{title}</Heading>
          <Text color="fg.muted" fontSize="md">
            {description}
          </Text>
        </VStack>

        <VStack gap={3} w="full" pt={4}>
          <Button
            size="lg"
            
            w="full"
            onClick={() => window.location.reload()}
          >
            <MdRefresh /> Try Again
          </Button>
          <Button
            variant="outline"
            size="lg"
            w="full"
            onClick={() => navigate(route('home'), { replace: true })}
          >
            <MdHome /> Go to Homepage
          </Button>
        </VStack>
      </VStack>
    </Box>
  );
}
